import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ssoApi, type UpdateSsoRequest } from "@repo/api";
import { ssoQueryKeys } from "../queryKeys";

export const useUpdateSso = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateSsoRequest) => ssoApi.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ssoQueryKeys.config });
    },
  });
};
